export enum TipoOperacaoEnum{
    error = 0,
    criar = 1,
    editar = 2,
    deletar = 3,
    baixaCupom = 4
}